import {
  ApartmentOutlined,
  AuditOutlined,
  ClusterOutlined,
  ContainerOutlined,
  FileProtectOutlined,
  GlobalOutlined,
  IdcardOutlined,
  ReconciliationOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { DashboardCbsIcon, MessagesCbsIcon } from 'assets/svg';
import { AudioLines, ChartColumnStacked, Earth } from 'lucide-react';

const RouteList = {
  'incident-management': [
    // {
    //   name: 'เรียกคิว',
    //   icon: <TeamOutlined />,
    //   path: `/app/incident-management/queue-access`,
    //   query: {
    //     group: 'queue_management',
    //     type: 'คิว',
    //   },
    // },
    {
      name: 'รายงาน',
      icon: <ReconciliationOutlined style={{ marginRight: 0 }} />,
      path: `/app/incident-management/report`,
      query: {
        group: 'Incident Management',
      },
      children: [
        // {
        //   name: 'รายงานประจำวัน',
        //   icon: <FileDoneOutlined />,
        //   path: '/daily',
        //   query: {
        //     group: 'Incident Management',
        //     type: 'รายงานประจำวัน',
        //   },
        // },
        // {
        //   name: 'รายงานภายในองค์กร',
        //   icon: <AuditOutlined />,
        //   path: '/internal',
        //   query: {
        //     group: 'Incident Management',
        //     type: 'รายงานภายในองค์กร',
        //   },
        // },
        {
          name: 'รายงานแจ้งเหตุออนไลน์',
          icon: <FileProtectOutlined />,
          path: '/online',
          query: {
            group: 'Incident Management',
            type: 'รายงานการแจ้งเหตุออนไลน์',
          },
        },
        // {
        //   name: 'รายงานจากเว็บฟอร์ม',
        //   icon: <ExceptionOutlined />,
        //   path: '/webform',
        //   query: {
        //     group: 'Incident Management',
        //     type: 'รายงานจากเว็บฟอร์ม',
        //   },
        // },
        // {
        //   name: 'รายงานการปฏิบัติหน้าที่',
        //   icon: <SolutionOutlined />,
        //   path: '/onduty',
        //   query: {
        //     group: 'Incident Management',
        //     type: 'รายงานการปฏิบัติหน้าที่',
        //   },
        // },
        // {
        //   name: 'รายงานรับแจ้งเหตุ 191',
        //   icon: <FileProtectOutlined />,
        //   path: '/191',
        //   query: {
        //     group: 'Incident Management',
        //     type: 'รายงานรับแจ้งเหตุ 191',
        //   },
        // },
      ],
    },
    // {
    //   name: 'ประเภทรายงาน',
    //   icon: <GroupOutlined />,
    //   path: '/app/incident-management/setting/genre',
    //   query: {
    //     group: 'Incident Management',
    //     type: 'ประเภทรายงาน',
    //   },
    // },
    // {
    //   name: 'ตั้งค่าเว็บฟอร์ม',
    //   icon: <SettingOutlined />,
    //   path: '/app/incident-management/setting/webform',
    //   query: {
    //     group: 'Incident Management',
    //     type: 'เว็บฟอร์ม',
    //   },
    // },
    // {
    //   name: 'รหัส ความผิด/เหตุการณ์',
    //   icon: <LockOutlined />,
    //   path: '/app/incident-management/setting/identities-code',
    //   query: {
    //     group: 'Incident Management',
    //     type: 'รหัสความผิด',
    //   },
    // },
    // {
    //   name: "นำเข้าข้อมูล",
    //   icon: <DownloadOutlined />,
    //   path: `/app/incident-management/import-report`,
    //   query: {
    //     group: "incident_management",
    //   },
    // },
  ],
  personnel: [
    {
      name: 'กำลังพล',
      icon: <IdcardOutlined />,
      path: '/app/personnel',
      query: {
        group: 'Personnel',
        type: 'กำลังพล',
      },
    },
    // {
    //   name: 'ตารางปฏิบัติหน้าที่',
    //   icon: <CalendarOutlined />,
    //   path: '/app/personnel/schedule',
    //   query: {
    //     group: 'Personnel',
    //     type: 'ตารางปฏิบัติหน้าที่',
    //   },
    // },
    // {
    //   name: 'ชุดปฏิบัติการ',
    //   icon: <TeamOutlined />,
    //   path: '/app/personnel/team',
    //   query: {
    //     group: 'Personnel',
    //     type: 'ชุดปฏิบัติการ',
    //   },
    // },
    // {
    //   name: 'แผนผังภายในองค์กร',
    //   icon: <ApartmentOutlined />,
    //   path: '/app/personnel/organize-chart',
    //   query: {
    //     group: 'Personnel',
    //     type: 'กำลังพล',
    //   },
    // },
    // {
    //   name: 'นำเข้าข้อมูล',
    //   icon: <DownloadOutlined />,
    //   path: '/app/personnel/import-report-force',
    //   query: {
    //     group: 'Personnel',
    //     type: 'กำลังพล',
    //     name: 'แก้ไขข้อมูลกำลังพล',
    //   },
    // },
    {
      name: 'ตั้งค่า',
      icon: <SettingOutlined />,
      path: '/app/personnel/setting',
      query: {
        group: 'Personnel',
        type: ['ตำแหน่ง', 'ฝ่ายงาน'],
      },
      children: [
        {
          name: 'ตำแหน่ง',
          icon: <ApartmentOutlined />,
          path: '/position',
          query: {
            group: 'Personnel',
            type: 'ตำแหน่ง',
          },
        },
        {
          name: 'ฝ่ายงาน',
          icon: <ClusterOutlined />,
          path: '/department',
          query: {
            group: 'Personnel',
            type: 'ฝ่ายงาน',
          },
        },
        // {
        //   name: 'องค์กร',
        //   icon: <BankOutlined />,
        //   path: '/organization',
        //   query: {
        //     group: 'Personnel',
        //     type: 'กำลังพล',
        //   },
        // },
      ],
    },
  ],
  poi: [
    {
      name: 'แดชบอร์ด',
      icon: <IdcardOutlined />,
      path: '/app/poi',
    },
    {
      name: 'พื้นที่รับผิดชอบ',
      icon: <IdcardOutlined />,
      path: '/app/poi/place-mornitor',
    },
    {
      name: 'ผู้รับผิดชอบแต่ละพื้นที่',
      icon: <IdcardOutlined />,
      path: '/app/poi/',
    },
    {
      name: 'ข้อมูลสารสนเทศภูมิศาสตร์',
      icon: <IdcardOutlined />,
      path: '/app/poi/',
    },
  ],
  'mass-notification': [
    {
      name: 'Mass Notification',
      icon: <AuditOutlined />,
      path: '/app/one-command/mass-notification',
      query: {
        group: 'mass-notification',
      },
    },
    {
      name: 'ตั้งค่า',
      icon: <SettingOutlined />,
      path: '/app/one-command/mass-notification',
      query: {
        group: 'mass-notification',
      },
      children: [
        {
          name: 'ประเภทการเตือน',
          icon: <ContainerOutlined />,
          path: '/setting',
          query: {
            group: 'mass-notification',
          },
        },
      ],
    },
  ],
  cbs: [
    {
      name: 'Dashboard',
      icon: (
        <span className="anticon">
          <DashboardCbsIcon width={14} height={14} />
        </span>
      ),
      path: '/app/one-command/cbs',
    },
    {
      name: 'รายการข้อความ',
      icon: (
        <span className="anticon">
          <MessagesCbsIcon width={14} height={15} />
        </span>
      ),
      path: '/app/one-command/cbs/list',
    },
    {
      name: 'การตั้งค่า',
      icon: <SettingOutlined />,
      path: '/app/one-command/cbs/setting',

      children: [
        {
          name: 'Master Data',
          icon: <ContainerOutlined />,
          path: '/master-data',
        },
      ],
    },
  ],
  'online-scam': [
    {
      name: 'ภาพรวมคดี',
      icon: (
        <span className="anticon">
          <ChartColumnStacked width={14} height={14} />
        </span>
      ),
      path: '/app/online-scam/dashboard',
      query: {
        group: 'Online Scam',
        // name: '',
      },
    },
    {
      name: 'คดีออนไลน์',
      icon: (
        <span className="anticon">
          <Earth width={14} height={14} />
        </span>
      ),
      path: '/app/online-scam',
      query: {
        group: 'Online Scam',
        // name: '',
      },
    },
    {
      name: 'ระบบถอดเสียงการสอบปากคำ',
      icon: (
        <span className="anticon">
          <AudioLines width={14} height={15} />
        </span>
      ),
      path: '/app/online-scam/voice',
      query: {
        group: 'Online Scam',
        // name: '',
      },
    },
    {
      name: 'รายงานการสืบสวน',
      icon: (
        <span className="anticon">
          <GlobalOutlined width={14} height={15} />
        </span>
      ),
      path: '/app/online-scam/investigation',
      query: {
        group: 'Online Scam',
        // name: '',
      },
    },
  ],
};

export default RouteList;
